
<div class="filter-container" style="width: 95%; margin: 0 auto;">
  <div class="row mt-5">
    <div class="col-md-12">
      <ejs-multiselect id='multiselectelement'
                       #selectObj
                       [fields]="fields"
                       [dataSource]='filters.users'
                       placeholder='Select Assigned User'
                       [formControl]="filtersForm.controls.users"
                       allowFiltering="true"

      >
      </ejs-multiselect>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-md-3">
      <ejs-multiselect
        [dataSource]='filters.priorities'
        placeholder='Select Priority'
        [formControl]="filtersForm.controls.priorities"
        allowFiltering="true"
      >
      </ejs-multiselect>
    </div>

    <div class="col-md-3">
      <ejs-multiselect
        [dataSource]='filters.statuses'
        placeholder='Select Status'
        [formControl]="filtersForm.controls.statuses"
        allowFiltering="true"
      >
      </ejs-multiselect>
    </div>

    <div class="col-md-3">
      <ejs-multiselect
        [dataSource]='filters.arts'
        placeholder='Select Art'
        [formControl]="filtersForm.controls.arts"
        allowFiltering="true"
      >
      </ejs-multiselect>
    </div>

    <div class="col-md-3">
      <div class="form-group hasValue">
        <ejs-daterangepicker #dateObj
                             [startDate]="thisYearStart" [endDate]="today"
                             style="margin-top: 8px;"
                             (change)="dateChanged($event)"
                             placeholder='Select a range'>
          <e-presets>
            <e-preset label="This Week" [start]='weekStart' [end]='weekEnd'></e-preset>
            <e-preset label="This Month" [start]='monthStart' [end]='monthEnd'></e-preset>
            <e-preset label="Last Month" [start]='lastStart' [end]='lastEnd'></e-preset>
            <e-preset label="Last Year" [start]='lastYearStart' [end]='lastYearEnd'></e-preset>
          </e-presets>
        </ejs-daterangepicker>
      </div>
    </div>
  </div>
</div>




<div class="row mt-5">
  <div class="col-md-12">
    <ejs-chart *ngIf="ticketVolumeAndAvgData" style='display:block;' width='100%' align='center' id='chartcontainer' [primaryXAxis]='primaryXAxis'
               [primaryYAxis]='primaryYAxis' [title]="'Ticket Volume and Average Resolution Time by Priority' | translate"  [tooltip]='tooltip' [legendSettings]='legend'>
      <e-series-collection>
        <e-series [dataSource]='ticketVolumeAndAvgData' type='Column' xName='priority' yName='ticket_volume' name='Ticket Volume' [cornerRadius]='cornerRadius' legendShape='Rectangle' columnSpacing='0.4' fill="#357cd2"> </e-series>
        <e-series [dataSource]='ticketVolumeAndAvgData' type='Column' xName='priority' yName='avg_resolution_time' name='Average Resolution Time' [cornerRadius]='cornerRadius' legendShape='Rectangle' columnSpacing='0.4' fill="#40b681"> </e-series>
      </e-series-collection>
    </ejs-chart>
  </div>
</div>

<div class="row mt-5">
  <div class="col-md-5">
    <ejs-accumulationchart id="container" #pie style='display:block;  width: 92%' [legendSettings]="legendSettings" [tooltip]="ticketsByStatusTooltip" [title]="'Tickets by Status'| translate" [enableAnimation]="true" [enableBorderOnMouseMove]='false'>
      <e-accumulation-series-collection>
        <e-accumulation-series name='status' [dataSource]='ticketsByStatusData' xName='status' yName='ticket_count' [startAngle]='startAngle' innerRadius="0%" [radius]="radius" [dataLabel]="dataLabel" [explode]='true' explodeOffset='10%' [explodeIndex]='explodeIndex'>
        </e-accumulation-series>
      </e-accumulation-series-collection>
    </ejs-accumulationchart>
  </div>
  <div class="col-md-7">
    <ejs-chart #chart style='display:block;' [primaryXAxis]='trendsprimaryXAxis'  width='100%' [primaryYAxis]='trendsPrimaryYAxis' [tooltip]='trendsTooltip' [chartArea]='trendsChartArea' [title]="'Ticket Trends Over Time' | translate" [legendSettings]='legendSettings'>
      <e-series-collection>
        <e-series [dataSource]='trendsData' type='Spline' xName='month_end' yName='ticket_count' name='Ticket Count' [marker]='trendsMarker'>
        </e-series>
      </e-series-collection>
    </ejs-chart>
  </div>
</div>

<div class="row mt-5">
  <div class="col-md-12">
    <ejs-chart *ngIf="averageResolutionTimeAndTotalAssigneeData" style='display:block;' width='100%' align='center' id='chartcontainer-assignee' [primaryXAxis]='primaryXAxisAssignee'
               [primaryYAxis]='primaryYAxisAssignee' [title]="'Average Resolution Time and Total Tickets by Assignee' | translate" [tooltip]='tooltip' [legendSettings]='legend'>
      <e-series-collection>
        <e-series [dataSource]='averageResolutionTimeAndTotalAssigneeData' type='Column' xName='assigned_user_name' yName='avg_resolution_time' name='Average Resolution Time' [cornerRadius]='cornerRadius' legendShape='Rectangle' columnSpacing='0.4' fill="#357cd2"> </e-series>
        <e-series [dataSource]='averageResolutionTimeAndTotalAssigneeData' type='Column' xName='assigned_user_name' yName='total_tickets' name='Total Tickets' [cornerRadius]='cornerRadius' legendShape='Rectangle' columnSpacing='0.4' fill="#40b681"> </e-series>
      </e-series-collection>
    </ejs-chart>
  </div>
</div>

<div class="row mt-5">
  <div class="col-md-12">
    <ejs-chart *ngIf="ticketsByCategoryData" style='display:block;' width='100%' align='center' id='chartcontainer-by-category' [primaryXAxis]='primaryXAxisAssignee'
               [primaryYAxis]='primaryYAxisByCategory' [title]="'Tickets by Issue Category' | translate" [tooltip]='tooltip' [legendSettings]='legend'>
      <e-series-collection>
        <e-series [dataSource]='ticketsByCategoryData' type='Column' xName='ticket_category' yName='ticket_count' name='Issue Category' [cornerRadius]='cornerRadius' legendShape='Rectangle' columnSpacing='0.4' fill="#357cd2"> </e-series>
      </e-series-collection>
    </ejs-chart>
  </div>
</div>
<div class="row mt-5">
  <div class="col-md-12">
    <ejs-chart *ngIf="ticketsByArtData" style='display:block;' width='100%' align='center' id='chartcontainer-by-art' [primaryXAxis]='primaryXAxisByArt'
               [primaryYAxis]='primaryYAxisByArt' [title]="'Issues by Art (Bug vs Improvement)' | translate" [tooltip]='tooltip' [legendSettings]='legend'>
      <e-series-collection>
        <e-series [dataSource]='ticketsByArtData' type='Column' xName='art' yName='issue_count' name='Art' [cornerRadius]='cornerRadius' legendShape='Rectangle' columnSpacing='0.4' fill="#357cd2"> </e-series>
      </e-series-collection>
    </ejs-chart>
  </div>
</div>


